var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBoundingBox(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5330_3232",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5330_3232)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.44995 8.5L7.72495 7.775C8.30828 7.20833 8.96662 6.771 9.69995 6.463C10.4333 6.15433 11.2 6 12 6C12.8 6 13.5666 6.15433 14.3 6.463C15.0333 6.771 15.6916 7.20833 16.275 7.775L15.55 8.5C15.0666 8.01667 14.525 7.64567 13.925 7.387C13.325 7.129 12.6833 7 12 7C11.3166 7 10.675 7.129 10.075 7.387C9.47495 7.64567 8.93328 8.01667 8.44995 8.5ZM5.64995 5.6L4.94995 4.9C5.88328 3.96667 6.95828 3.25 8.17495 2.75C9.39162 2.25 10.6666 2 12 2C13.3333 2 14.6083 2.25 15.825 2.75C17.0416 3.25 18.1166 3.96667 19.05 4.9L18.35 5.6C17.5 4.76667 16.525 4.125 15.425 3.675C14.325 3.225 13.1833 3 12 3C10.8166 3 9.67495 3.225 8.57495 3.675C7.47495 4.125 6.49995 4.76667 5.64995 5.6ZM13.625 21.225H10.375C9.92495 21.225 9.54595 21.071 9.23795 20.763C8.92928 20.4543 8.77495 20.075 8.77495 19.625V12.375C8.77495 11.925 8.92928 11.5457 9.23795 11.237C9.54595 10.929 9.92495 10.775 10.375 10.775H13.625C14.075 10.775 14.4543 10.929 14.763 11.237C15.071 11.5457 15.225 11.925 15.225 12.375V19.625C15.225 20.075 15.071 20.4543 14.763 20.763C14.4543 21.071 14.075 21.225 13.625 21.225ZM13.625 20.225C13.775 20.225 13.9126 20.1627 14.038 20.038C14.1626 19.9127 14.225 19.775 14.225 19.625V12.375C14.225 12.225 14.1626 12.0873 14.038 11.962C13.9126 11.8373 13.775 11.775 13.625 11.775H10.375C10.225 11.775 10.0876 11.8373 9.96295 11.962C9.83762 12.0873 9.77495 12.225 9.77495 12.375V19.625C9.77495 19.775 9.83762 19.9127 9.96295 20.038C10.0876 20.1627 10.225 20.225 10.375 20.225H13.625ZM13.625 20.225H9.77495H14.225H13.625Z",
    fill: "#1C1B1F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoundingBox);
export default __webpack_public_path__ + "static/media/BoundingBox.616fb33545a94681e180e99ea8181575.svg";
export { ForwardRef as ReactComponent };